module.exports = __webpack_public_path__ + "static/media/footer.78e9f7fa.jpg";